<template>
  <section class="report-issue">
    <div class="report-issue__background" aria-hidden="true">
      <img
        src="/images/svg/report-issue-background.svg"
        class="report-issue__background-image"
      />
    </div>
    <div class="container">
      <div class="report-issue__content">
        <StoryblokComponent
          v-for="element in blok.content"
          :key="element._uid"
          :blok="element"
        />
        <BaseCard
          :options="['is_full_width']"
          class="newsletter-card"
          shadow="shadow-flat-soft"
          :padding="{ mobile: 36, tablet: 48, desktop: 48 }"
          :border-radius="16"
        >
          <FormReportIssue />
        </BaseCard>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbHeroReportIssue } from '@/types'

interface Props {
  blok: SbHeroReportIssue
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.report-issue {
  position: relative;

  &__content {
    padding-top: 64px;
    padding-bottom: 64px;
    max-width: 658px;
    margin: 0 auto;

    @media (min-width: $breakpoint-lg) {
      padding-top: 96px;
    }
  }

  &__background {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    height: 698px;
    width: 100%;
    background-color: var(--paper-100);
  }

  &__background-image {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
